import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { FEBRUARY_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(FEBRUARY_2025_CAMPAIGN_END_DATE);
